import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    clearAddEditModalValue,
    setIsConfirmationModalOpen,
    setLockedTime,
    setModalOpen,
    setModalType,
    setParseDataOfCsvFile,
    setSelectedCsvFile,
    setSelectedCsvFileName,
    setSelectedCsvItem,
    setSelectedCsvItemIndex,
    setSelectedItem
} from 'store/ResponseTemplate/actions';
import { Box, Modal } from '@mui/material';
import AddNewTemplate from './AddNewTemplate';
import DeleteTemplate from './DeleteTemplate';
import PermanentDeleteTemplate from './PermanentDeleteTemplate';
import AddTemplateSuccess from './AddTemplateSuccess';
import AddTemplateFailed from './AddTemplateFailed';
import EditTemplate from './EditTemplate';
import PreviewTemplate from './PreviewTemplate';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ViewQuestionRegistries from './ViewQuestionRegistry';
import LockWrapper from 'Components/LockWrapper';
import { UPDATE_LOCK_QUESTION_REGISTRY_DETAIL } from 'schemas/mutation';
import { useMutation } from '@apollo/client';
import ImportCsvTemplate from './ImportCsvTemplate';
import CSVDataListTemplate from './CsvDataListTemplate';
import RemoveTemmplateCsv from './RemoveTemplateCsv';
import EditTemplateCSV from './EditTemplateCSV';
import DeleteTemplateCSV from './DeleteTemplateCSV';
import UpgradePremiumMoreThanThreeQuestion from './UpgradePremiumMoreThanThreeQuestion';
import UpgradeImportQuestions from './UpgradeImportQuestions';
import ReturnBackCSVImport from './ReturnBackCSVImport';
import CancelImportCSV from './CancelImportCSV';
function ResponseTemplateModal() {
    const { hasInputValue, hasInputNoChange, modalOpen, modalType, lockedTime, selectedItem } = useSelector((params) => params.response);
    const { companyData } = useSelector((params) => params.customization);
    const dispatch = useDispatch();
    const [updateLockedTime] = useMutation(UPDATE_LOCK_QUESTION_REGISTRY_DETAIL);
    const handleClose = () => {
        if (modalType === 'add' || modalType === 'edit') {
            if (hasInputValue && !hasInputNoChange) {
                dispatch({ type: setIsConfirmationModalOpen, isConfirmationModalOpen: true });
                return;
            } else {
                dispatch({ type: setModalOpen, modalOpen: false });
                dispatch({ type: setIsConfirmationModalOpen, isConfirmationModalOpen: false });
                dispatch({ type: clearAddEditModalValue });
            }
        } else {
            dispatch({ type: setModalOpen, modalOpen: false });
            if (modalType !== 'edit_csv' && modalType !== 'remove_csv') {
                dispatch({ type: setSelectedCsvFile, selectedCsvFile: null });
                dispatch({ type: setSelectedCsvFileName, selectCsvFileName: '' });
                dispatch({ type: setParseDataOfCsvFile, parsedCsvData: [] });
            } else {
                dispatch({ type: setSelectedCsvItem, selectedCsvItem: null });
                dispatch({ type: setSelectedCsvItemIndex, selectedCsvItemIndex: -1 });
                dispatch({ type: setModalType, modalType: 'list_csv_data' });
                dispatch({ type: setModalOpen, modalOpen: true });
            }
        }
    };

    /**For Editing Lock what to after locked time expires */
    const onFinishLock = () => {
        dispatch({ type: setIsConfirmationModalOpen, isConfirmationModalOpen: false });
        dispatch({ type: setSelectedItem, selectedItem: selectedItem });
        dispatch({ type: setModalOpen, modalOpen: false });
        dispatch({ type: setModalOpen, modalOpen: true });
        dispatch({ type: setModalType, modalType: 'view or edit' });
    };

    /**For Updating Lock */
    const onUpdateLock = async (item, type) => {
        try {
            let variables = {
                updateQuestionRegistryLockedTime: {
                    companyId: companyData._id,
                    type: type,
                    registryId: item._id
                }
            };
            const response = await updateLockedTime({
                variables: {
                    ...variables
                }
            });
            dispatch({
                type: setLockedTime,
                lockedTime: response.data.updateQuestionRegistryLockedTime
            });
        } catch (e) {
            console.log('===error', e);
        }
    };
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24
    };
    if (modalType === 'list_csv_data') return <CSVDataListTemplate />;
    return (
        <Modal open={modalOpen} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <Box sx={style} className={`modal-box ${modalType}`}>
                {modalType === 'delete' && <DeleteTemplate />}
                {modalType === 'delete-csv' && <DeleteTemplateCSV />}
                {modalType === 'upgrade-premium-more-than-three-questions' && <UpgradePremiumMoreThanThreeQuestion />}
                {modalType === 'upgrade-import-questions' && <UpgradeImportQuestions />}
                {modalType === 'return-back-csv-import' && <ReturnBackCSVImport />}
                {modalType === 'cancel-import-csv' && <CancelImportCSV />}

                {modalType !== 'delete' && (
                    <PerfectScrollbar
                        style={{ maxHeight: 'calc(100vh - 72px)', padding: '0 12px' }}
                        options={{ suppressScrollX: true, useBothWheelAxes: false }}
                    >
                        {modalType === 'add' && <AddNewTemplate />}
                        {modalType === 'import-csv' && <ImportCsvTemplate />}
                        {modalType === 'delete-permanently' && <PermanentDeleteTemplate />}
                        {modalType === 'success' && <AddTemplateSuccess />}
                        {modalType === 'failed' && <AddTemplateFailed />}
                        {modalType === 'remove_csv' && <RemoveTemmplateCsv />}
                        {modalType === 'edit_csv' && <EditTemplateCSV />}
                        {modalType === 'edit' && (
                            <LockWrapper
                                item={selectedItem}
                                lockedTime={lockedTime}
                                onFinishLock={onFinishLock}
                                updateLockedTime={onUpdateLock}
                            >
                                <EditTemplate />
                            </LockWrapper>
                        )}
                        {modalType === 'preview' && <PreviewTemplate />}
                        {modalType === 'view or edit' && <ViewQuestionRegistries />}
                    </PerfectScrollbar>
                )}
            </Box>
        </Modal>
    );
}

export default ResponseTemplateModal;
